export const getIntercomAppURL = (dataCenter: 'us' | 'eu' | 'au' = 'us') => {
  switch (dataCenter) {
    case 'eu':
      return 'https://app.eu.intercom.com';
    case 'au':
      return 'https://app.au.intercom.com';
    default:
      return 'https://app.intercom.com';
  }
};

export default getIntercomAppURL;
